

<div class="top-background" style="background-image:url(images/backgrounds/contact.jpg);">
    <h1 class="page-title">Contact Us</h1>
    <!-- Credit to the photographer (not required but still giving it) -->
    <div class="credit">
        Photo by <a href="https://unsplash.com/@wesley_squared?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Wesley Hilario</a>
    </div>
</div>

<section id="contact">

    <div class="content">
        <div class="flex-wrapper">
            <div class="flex-item">
                <h1>Life Cycle Management Laboratory</h1>
                <h4>Okanagan Campus</h4>
                <p>EME 3287-1137 Alumni Avenue <br> Kelowna, BC Canada V1V 1V7</p>
            </div>
            <div class="flex-item">
                <ul>
                    <!-- Dr. Hewage's Contact Info -->
                    <li>
                        <img src="images/people/kasun-hewage.png" alt="Kasun Hewage's profile"/>
                        <h3 class="name">Dr. Kasun Hewage</h3>
                        <div class="contact-text">
                            <img src="images/icons/phone-contact.png" alt="Call">
                            <p>(250) 807 8176</p>
                        </div>
                        <div class="contact-text">
                            <img src="images/icons/email-contact.png" alt="Email">
                            <a href="mailto:kasun.hewage@ubc.ca">kasun.hewage@ubc.ca</a>
                        </div>
                    </li>
                    <!-- Dr. Sadiq's Contact Info -->
                    <li>
                        <img src="images/people/rehan-sadiq.jpg" alt="Rehan Sadiq's profile"/>
                        <h3 class="name">Dr. Rehan Sadiq</h3>
                        <div class="contact-text">
                            <img src="images/icons/phone-contact.png" alt="Call">
                            <p>(250) 807 9013</p>
                        </div>
                        <div class="contact-text">
                            <img src="images/icons/email-contact.png" alt="Email">
                            <a href="mailto:kasun.hewage@ubc.ca">rehan.sadiq@ubc.ca</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</section>




<style lang="sass">

@import "../consts.sass"
@include page-header()

.content
    padding: 2em
    box-sizing: border-box

    @media only screen and (min-width: 1200px) 
        padding-right: 10vw
        padding-left: 10vw

    .flex-wrapper
        margin: 2rem 0
        display: flex
        flex-direction: row
        justify-content: space-between

        @media only screen and (max-width: 1200px) 
            flex-direction: column
            flex-flow: wrap
            justify-content: flex-start

        .flex-item ul
            display: flex
            flex-direction: row
            list-style-type: none

            @media only screen and (max-width: 1200px) 
                flex-flow: wrap

                li
                    margin-top: 3em
                    margin-right: 0

            li
                display: flex
                flex-direction: column
                justify-content: space-between
                width: 15em
                margin-right: 5em

                img
                    border-radius: 0.2em

                .contact-text
                    display: flex
                    flex-direction: row
                    align-items: center

                    img
                        margin-right: 1em
                        height: 1.3em

                    a,p
                        color: $color_primary
                        text-decoration: none
                        font-size: 1em
                        margin: 0 !important


                



        
                    



</style>